module.exports = __webpack_public_path__ + "static/Bitmap_2.70745408.png";